<template>
  <div>
    <div class="reservation-container">
      <div class="reservation-img">
        <img src="./image/pc.jpg" v-if="$store.state.pageset.pcshow" />
        <img src="./image/pc.jpg" v-else />
      </div>
      <div class="reservation-container-form">
        <p class="p1">今日已有{{ todayNumber }}人下单咨询</p>
        <p class="p2" v-animate="'queue-bottom'">智选闪送，巡检无忧。</p>
        <p class="p2" v-animate="'queue-bottom'">感谢您的关注!</p>
        <p class="p2" v-animate="'queue-bottom'">
          请留下您的信息，我们将尽快联系你沟通具体需求!
        </p>
        <el-form ref="form" :rules="formRules" :model="form">
          <el-form-item prop="name" v-animate="'queue-bottom'">
            <el-input v-model="form.name" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item prop="corporateName" v-animate="'queue-bottom'">
            <el-input
              v-model="form.corporateName"
              placeholder="公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item v-animate="'queue-bottom'" prop="phone">
            <el-input v-model="form.phone" placeholder="手机号码"></el-input>
          </el-form-item>

          <el-form-item prop="usageScenario" v-animate="'queue-bottom'">
            <el-input v-model="form.usageScenario" placeholder="使用场景"></el-input>
          </el-form-item>
          <el-form-item v-animate="'queue-bottom'" prop="intendedProduct">
            <el-select
              style="width: 100%"
              v-model="form.intendedProduct"
              placeholder="意向产品"
            >
              <el-option
                v-for="item in productOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="serviceSelection" v-animate="'queue-bottom'">
            <el-select
              style="width: 100%"
              v-model="form.serviceSelection"
              placeholder="服务选择"
            >
              <el-option
                v-for="item in intentionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button
          size="small"
          class="btn-div-experience black-btn"
          plain
          @click="orderNow"
          :loading="orderLoading"
          >立即下单</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import index from "./index.js";

export default index;
</script>
<style scoped lang="scss">
@import "index.scss";
@import "@/assets/style/common.scss";
</style>
